"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _breakpoint = _interopRequireDefault(require("../theming/breakpoint"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var removeMargin = function removeMargin(properties) {
  var output = {};
  var toRemove = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft'];
  Object.keys(properties).forEach(function (property) {
    if (_typeof(properties[property]) === 'object') {
      output[property] = removeMargin(properties[property]);
    } else if (!toRemove.includes(property)) {
      output[property] = properties[property];
    }
  });
  return output;
};

var search = function search(theme, keys) {
  return keys.reduce(function (acc, key) {
    return acc && acc[key] || {};
  }, theme.typo);
};

var _default = function _default(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? true : _ref$margin;
  var keys = variant.split('-');
  var variantValues = search(theme, keys);

  var _ref2 = margin ? variantValues : removeMargin(variantValues),
      sm = _ref2.sm,
      md = _ref2.md,
      lg = _ref2.lg,
      xl = _ref2.xl,
      xs = _objectWithoutProperties(_ref2, ["sm", "md", "lg", "xl"]);

  var textStyles = xs;

  if (sm) {
    textStyles[_breakpoint["default"].sm()] = sm;
  }

  if (md) {
    textStyles[_breakpoint["default"].md()] = md;
  }

  if (lg) {
    textStyles[_breakpoint["default"].lg()] = lg;
  }

  if (xl) {
    textStyles[_breakpoint["default"].xl()] = xl;
  }

  return textStyles;
};

exports["default"] = _default;